const CACHE_SEARCH_PARAMS = {
    ignoreMethod: true,
    ignoreSearch: true,
};

const _openCache = (name: string): Promise<Cache> =>
    caches === undefined ? Promise.reject('No caches available') : caches.open(name);

const _insertToCache = (cache: Cache, request: Request, response: Response): Promise<void> =>
    cache.put(request, response);

const _isInCache = async (cache: Cache, request: Request): Promise<boolean> => {
    const result = await caches.match(request, CACHE_SEARCH_PARAMS).catch(error => undefined);
    return result ? true : false;
};

const module = {
    open: _openCache,
    insert: _insertToCache,
    exists: _isInCache,
};

export default module;
